
const SET_LISTRECORDEXAM = (state, payload) => {
  state.list = payload
}

const SETCREATERECORDEXAME = (state, payload) => {
  state.createRecordExam = payload
}

export default {
  SETCREATERECORDEXAME,
  SET_LISTRECORDEXAM
}



// WEBPACK FOOTER //
// ./src/store/modules/examination-report/mutations.js